import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, push, onValue, remove, update } from 'firebase/database';

const AccountGroup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const [view, setView] = useState('list'); // 'list' or 'form'
  const [searchTerm, setSearchTerm] = useState('');
  const [accountGroups, setAccountGroups] = useState([]);
  
  // Edit State
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // Form State
  const initialFormState = {
    type: 'मालमत्ता', // default
    groupNo: '',
    groupName: '',
    groupNameEng: ''
  };

  const [formData, setFormData] = useState(initialFormState);

  // Fetch Data
  useEffect(() => {
    const groupsRef = ref(database, 'Grampanchayat/Panipuravtha/AccountGroups');
    const unsubscribe = onValue(groupsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadGroups = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setAccountGroups(loadGroups);
      } else {
        setAccountGroups([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = () => {
    if (!formData.groupName) {
      alert("Please fill in Group Name");
      return;
    }

    if (isEditing && selectedId) {
      const groupRef = ref(database, `Grampanchayat/Panipuravtha/AccountGroups/${selectedId}`);
      update(groupRef, formData)
        .then(() => {
          alert("Data Updated Successfully!");
          resetForm();
        })
        .catch((error) => {
          console.error("Error updating data: ", error);
          alert("Error updating data");
        });
    } else {
      const groupsRef = ref(database, 'Grampanchayat/Panipuravtha/AccountGroups');
      push(groupsRef, formData)
        .then(() => {
            alert("Data Saved Successfully!");
            resetForm();
        })
        .catch((error) => {
          console.error("Error saving data: ", error);
          alert("Error saving data");
        });
    }
  };

  const resetForm = () => {
    setFormData(initialFormState);
    setIsEditing(false);
    setSelectedId(null);
    setView('list');
  };

  const handleEdit = (group) => {
    setFormData(group);
    setSelectedId(group.id);
    setIsEditing(true);
    setView('form');
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      const groupRef = ref(database, `Grampanchayat/Panipuravtha/AccountGroups/${id}`);
      remove(groupRef)
        .then(() => {
          alert("Record deleted successfully");
        })
        .catch((error) => {
          console.error("Error deleting record: ", error);
          alert("Error deleting record");
        });
    }
  };

  const filteredGroups = accountGroups.filter(group => 
    group.groupName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.groupNo?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#267c77] rounded-lg shadow-sm p-4 flex justify-between items-center text-white">
            <div>
                 <h1 className="text-xl font-bold">
                    खाते गट माहिती
                 </h1>
            </div>
            <div className="flex gap-2">
                 <button 
                   onClick={() => navigate('/panipuravtha/permanent-info/account-info', { state: location.state })}
                   className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                 >
                   मागे जा
                 </button>
                 {view === 'list' && (
                   <button 
                     onClick={() => {
                        resetForm();
                        setView('form');
                     }}
                     className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition"
                   >
                     नविन
                   </button>
                 )}
            </div>
        </div>
      </div>

      {view === 'list' ? (
        /* LIST VIEW */
        <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          
          {/* Search Bar */}
          <div className="p-4 border-b border-gray-200">
             <div className="flex gap-4">
                <div className="relative flex-1">
                    <input 
                    type="text" 
                    placeholder="शोधणे" 
                    className="w-full px-4 py-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition">
                    शोधणे
                </button>
             </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#267c77] text-white">
                  <th className="p-3 border-r border-[#1e6b66] font-medium text-center w-32">खाते गट क्र.</th>
                  <th className="p-3 border-r border-[#1e6b66] font-medium">खाते गटाचे नाव</th>
                  <th className="p-3 border-r border-[#1e6b66] font-medium w-32">प्रकार</th>
                  <th className="p-3 font-medium text-center w-48">पर्याय</th>
                </tr>
              </thead>
              <tbody>
                  {filteredGroups.length > 0 ? (
                    filteredGroups.map((group) => (
                      <tr key={group.id} className="border-b hover:bg-gray-50">
                          <td className="p-3 text-center border-r">{group.groupNo}</td>
                          <td className="p-3 border-r">{group.groupName}</td>
                          <td className="p-3 border-r">{group.type}</td>
                          <td className="p-3 text-center flex justify-center gap-2">
                               <button 
                                onClick={() => handleEdit(group)}
                                className="px-4 py-1 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] font-medium"
                              >
                                बदल
                              </button>
                              <button 
                                onClick={() => handleDelete(group.id)}
                                className="px-4 py-1 bg-red-600 text-white rounded hover:bg-red-700 font-medium"
                              >
                                खोडणे
                              </button>
                          </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                        <td colSpan="4" className="p-4 text-center text-gray-500 bg-white">
                            No records found
                        </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

           {/* Pagination (Static per image) */}
           <div className="p-2 border-t bg-[#267c77] text-white flex justify-center items-center gap-2">
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">|&lt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&lt;&lt;</button>
                <span className="px-3 py-1 bg-white/20 rounded text-sm bg-[#1e6b66]">1</span>
                <span className="px-3 py-1 bg-white/20 rounded text-sm hover:bg-white/30 cursor-pointer">2</span>
                <span className="px-3 py-1 bg-white/20 rounded text-sm hover:bg-white/30 cursor-pointer">3</span>
                <span className="px-3 py-1 bg-white/20 rounded text-sm hover:bg-white/30 cursor-pointer">4</span>
                <span className="px-3 py-1 bg-white/20 rounded text-sm hover:bg-white/30 cursor-pointer">5</span>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;&gt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;|</button>
                <select className="ml-2 bg-white text-black text-sm p-1 rounded">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                </select>
           </div>
        </div>
      ) : (
        /* FORM VIEW */
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
             <div className="bg-[#267c77] text-white p-3 px-6">
                 <h2 className="text-lg font-medium">
                    खातेगट माहिती
                 </h2>
             </div>
            <div className="p-8 space-y-6">
                
                <div className="grid grid-cols-12 gap-4 items-center">
                    <label className="col-span-12 md:col-span-3 text-gray-700 font-medium">प्रकार:</label>
                    <div className="col-span-12 md:col-span-9">
                        <select 
                            name="type" 
                            value={formData.type} 
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-[#267c77]"
                        >
                            <option value="मालमत्ता">मालमत्ता</option>
                            <option value="देणी">देणी</option>
                            <option value="उत्पन्न">उत्पन्न</option>
                            <option value="खर्च">खर्च</option>
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-4 items-center">
                    <label className="col-span-12 md:col-span-3 text-gray-700 font-medium">खातेगट क्र.:</label>
                    <div className="col-span-12 md:col-span-9">
                        <input 
                            type="text" 
                            name="groupNo" 
                            value={formData.groupNo} 
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-[#267c77]/30 rounded bg-gray-100 focus:outline-none"
                            placeholder="खातेगट क्र."
                        />
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-4 items-center">
                    <label className="col-span-12 md:col-span-3 text-gray-700 font-medium">खातेगटाचे नाव:</label>
                    <div className="col-span-12 md:col-span-9">
                        <input 
                            type="text" 
                            name="groupName" 
                            value={formData.groupName} 
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-1 focus:ring-[#267c77]"
                            placeholder="Please Enter Group Name"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-4 items-center">
                    <label className="col-span-12 md:col-span-3 text-gray-700 font-medium">खातेगटाचे इंग्रजी नाव:</label>
                    <div className="col-span-12 md:col-span-9">
                        <input 
                            type="text" 
                            name="groupNameEng" 
                            value={formData.groupNameEng} 
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-1 focus:ring-[#267c77]"
                            placeholder="Please Enter Group Eng Name"
                        />
                    </div>
                </div>

            </div>

             {/* Footer Buttons */}
             <div className="flex justify-center gap-4 py-4 bg-[#267c77]">
                <button 
                  onClick={handleSave}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    साठविणे
                </button>
                <button 
                  onClick={() => setView('list')}
                  className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition font-medium"
                >
                    रद्द करणे
                </button>
             </div>
        </div>
      )}

    </div>
  );
};

export default AccountGroup;
